import styled from 'styled-components'

export const newFormThemeOverrides: any = {
    MuiSelect: {
        styleOverrides: {
            outlined: {
                textAlign: 'right',
            },
        },
    },
}

export const Status = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    .date {
        color: #666666;
    }
`

export const SmallCircle = styled.div`
    background-color: ${props => props.theme.color.status[props.color]};
    border-radius: 100%;
    width: 10px;
    height: 10px;
    margin-right: 10px;
`
